$(document).ready(function () {
    $(".tpl-product-category #product-filters").on("change", function () {
        let filters = {};

        $(".tpl-product-category #product-filters input:checked").each(
            function (index, input) {
                const propertyId = $(input).data("property");
                const propertyValueId = $(input).data("value");

                if (!filters[propertyId]) filters[propertyId] = [];

                filters[propertyId].push(propertyValueId);
            }
        );

        $(".tpl-product-category .product-display").each(function (
            index,
            product
        ) {
            let show = true;
            const properties = $(product).data("properties");
            for (let filterId of Object.keys(filters)) {
                if (
                    !properties[filterId] ||
                    !properties[filterId].some((value) =>
                        filters[filterId].includes(value)
                    )
                ) {
                    show = false;
                    break;
                }
            }

            if (show) $(product).fadeIn();
            else $(product).fadeOut();
        });
    });

    $(".tpl-product-category #product-filters label").on("click", function () {
        const input = $(this).parent().find("input");
        input.prop("checked", !input.prop("checked"));
        input.trigger("change");
    });
});
